interface LatLngConfig {
  lat: number

  lng: number
}
class LatLng {
  public readonly lat: number

  public readonly lng: number

  constructor(configuration: LatLngConfig) {
    this.lat = configuration.lat
    this.lng = configuration.lng
  }
}

export { LatLng, LatLngConfig }

export default LatLng
